module.exports = __webpack_public_path__ + "static/media/whitelogo.6f5d542e.png";